import useAlias from '@alias';
import storeConnector from '@store/storeConnector';
import { useEffect } from 'react';
import SunRiseSetWidget from './SunRiseSetWidget/SunRiseSetWidget';
import WeatherForecastWidget from './WeatherForecastWidget/WeatherForecastWidget';
import WindWidget from './WindWidget';

const WeatherWidget = ({
  actions,
  hideSun = false,
  hideWind = false,
  hideWeather = false,
}) => {
  const alias = useAlias();

  useEffect(() => {
    actions.getWeather();
  }, []);

  return (
    <div className='frow h100'>
      {!hideWeather && <WeatherForecastWidget title={alias('Weather')} />}
      {!hideSun && <SunRiseSetWidget />}
      {!hideWind && <WindWidget />}
    </div>
  );
};

export default storeConnector(WeatherWidget, {});
